/* eslint-disable no-unsafe-optional-chaining */
import { Box, Text } from "@quintoandar-tokko/jopijs";
import { useEffect, useRef, useState } from "react";
import style from "./ToolTip.module.scss";

export default function ToolTip({
  title,
  children,
  place = "top",
  outSideModal = false,
  maxWidth = "auto",
}) {
  const [hover, setHover] = useState(false);
  const [position, setPosition] = useState({
    bottom: "0px",
    arrow: "0px",
  });
  const [arrowPositionX, setArrowPositionX] = useState("50%");

  const refTip = useRef(null);
  const refWind = useRef(null);

  const handleMouse = () => setHover(!hover);

  useEffect(() => {
    const tipPositions = {
      bottom: `-${refTip.current.offsetHeight + 50}px`,
      top: `${refTip.current.offsetHeight + 2}px`,
    };
    if (outSideModal) {
      const modal = document
        .getElementById(outSideModal)
        .getBoundingClientRect();
      const tip = refTip.current.getBoundingClientRect();
      setPosition({
        ...position,
        bottom: "inherit",
        top: `${tip.top - modal.top - tip.height - 10}px`,
        left: `${
          tip.left -
          modal.left -
          (refWind.current?.offsetWidth - refTip.current.offsetWidth) / 2
        }px`,
      });
    } else {
      setPosition({
        ...position,
        bottom: tipPositions[place],
        arrow: `${(refTip.current.offsetHeight - 14) / 2}px`,
      });
      const elemWidth = refTip.current?.offsetWidth;
      const elemViewportUbic = refTip.current?.getBoundingClientRect();
      const patherWidth = refTip.current?.offsetParent?.offsetWidth;
      const toolTipWidth = maxWidth;
      const availableSpaceToRigth =
        patherWidth - elemViewportUbic.right + elemWidth / 2;
      const availableSpaceToLefth = elemViewportUbic.left + elemWidth / 2;
      if (toolTipWidth / 2 > availableSpaceToRigth) {
        const deviation =
          elemWidth / 2 + (availableSpaceToRigth - toolTipWidth / 2);
        setPosition({
          ...position,
          bottom: tipPositions[place],
          left: `${deviation}px`,
        });
        setArrowPositionX(toolTipWidth / 2 + elemWidth / 2 - deviation);
      } else if (toolTipWidth / 2 > availableSpaceToLefth) {
        const deviation =
          elemWidth / 2 + (toolTipWidth / 2 - availableSpaceToLefth);
        setPosition({
          ...position,
          bottom: tipPositions[place],
          left: `${deviation}px`,
        });
        setArrowPositionX(toolTipWidth / 2 + elemWidth / 2 - deviation);
      } else
        setPosition({ ...position, bottom: tipPositions[place], left: "50%" });
    }
  }, [refTip.current, hover]);

  return (
    <Box
      __css={{
        position: outSideModal ? "inherit" : "relative",
      }}
      onMouseEnter={handleMouse}
      onMouseLeave={handleMouse}
      className={style.container}
      ref={refTip}
    >
      {children}
      {hover && (
        <Box
          ref={refWind}
          className={`${style.tip} ${
            outSideModal ? "" : style.nonOutSideModal
          }`}
          style={{
            maxWidth: `${maxWidth}px`,
            bottom: position.bottom,
            top: position?.top,
            left: position?.left,
          }}
        >
          <Text variant="body.fontSize12">{title}</Text>
          <Box
            __css={{
              bottom:
                place === "bottom"
                  ? `${refWind.current?.offsetHeight - 6}px`
                  : "-5px",
              left: arrowPositionX,
            }}
            className={`${style.arrow} ${style[place]}`}
          />
        </Box>
      )}
    </Box>
  );
}
